export const SLIDE_DELAY = 6000;
export const PAGINATION_CLASS_NAME = "swiper-pagination";
export const NAVIGATION_NEXT_CLASS_NAME = "swiper-navigation-next";
export const NAVIGATION_PREV_CLASS_NAME = "swiper-navigation-prev";
